import React, { useContext, useEffect, useState } from "react";
import { SingleRowAssessment } from "../../components/List/SingleRowAssessment";

import AssessmentDataService from "../../services/Assessment";
import { listContext } from "./ListContext";

import { useDisclosure, useToast } from "@chakra-ui/react";

import { useNavigate } from "react-router-dom";
import { SingleTestAssessment } from "../../components/List/SingleTestAssessment";

export const TestAssessment = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const toast = useToast();
  const user = localStorage.getItem("logged_in_User");
  const localFilter =
    localStorage.getItem("assessment-list-filter-content") || "";
  const localSearch =
    localStorage.getItem("assessment-list-search-content") || "";
  const localPagesize = localStorage.getItem(
    "assessment-list-pageSize-content"
  );
  const localIsSort =
    localStorage.getItem("assessment-list-ehcdate-sorting") || "";
  const localFilteredDate = localStorage.getItem("assessment-list-filter-date");
  const newLocalFilteredDate = localFilteredDate
    ? JSON.parse(localFilteredDate)
    : { filterType: "", date: "" };
  const newlocalPagesize = localPagesize ? JSON.parse(localPagesize) : 7;
  const [lock, setLock] = useState({
    filterLock: localFilter !== "" ? true : false,
    searchLock: localSearch !== "" ? true : false,
    pageSizeLock: newlocalPagesize !== 7 ? true : false,
    sortingLock: localIsSort !== "" ? true : false,
    filterDateLock: localFilteredDate ? true : false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [data, setData] = useState<any>([]);

  const [leadOwner, setLeadOwner] = useState(
    user === "intern"
      ? "intern"
      : user === "expert"
      ? "expert"
      : user === "marketing"
      ? "marketing"
      : ""
  );
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalAssessments, setTotalAssessments] = useState(0);
  const [page, setPage] = useState(1);

  const [dateValue, setDateValue] = useState(newLocalFilteredDate.date);
  const [dateTypevalue, setDateTypeValue] = useState(
    newLocalFilteredDate.filterType
  );
  const [isEhcDateSort, setIsEhcDateSort] = useState(
    localIsSort ? "true" : "false"
  );

  const fetchData = () => {
    setIsLoading(true);
    AssessmentDataService.getAssessmentData(
      page,
      pageSize,

      token
    )
      .then((res) => {
        const data = res.data;
        setData(data.assessments);
        setTotalAssessments(data.totalAssessments);
        setTotalPages(data.totalPages);
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        if (e.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(e);
      });
  };

  const getFilteredDate = (
    date: string,
    dateType: string,
    lockValue: boolean
  ) => {
    setDateValue(date);
    setDateTypeValue(dateType);
    setLock({ ...lock, filterDateLock: lockValue });
  };

  useEffect(() => {
    fetchData();
  }, [page, pageSize, dateValue, isEhcDateSort]);
  return (
    <>
      <div className="main-wrapper">
        <div className="page_title py-2">Reachout - Wix Assessment</div>

        <div className=" p-4">
          {/* top section */}
          {/* Main secttion */}
          <div className="main-section">
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Assessment Taken Date</th>
                  <th>Assessment Type</th>
                  <th>Last Notification Sent</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((el: any) => (
                    <SingleTestAssessment
                      key={el.id}
                      props={el}
                      func={fetchData}
                    />
                  ))
                ) : (
                  <h1 className="no-data">No Data Found</h1>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination section */}
          <div className="row m-0 pagination pt-5">
            <div className="col-sm-6 p-lg-0">
              <p>
                Showing {(page - 1) * pageSize + 1} to{" "}
                {page * pageSize > totalAssessments
                  ? totalAssessments
                  : page * pageSize}{" "}
                of {totalAssessments} entries
              </p>
            </div>
            <div className="col-sm-6 p-lg-0 text-right">
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={
                    page === 1
                      ? "btn action-btn disabledButton "
                      : "btn action-btn"
                  }
                  onClick={() => setPage(page - 1)}
                  disabled={page === 1 ? true : false}
                >
                  {"<< Previous"}
                </button>
                <button type="button" className="btn action-btn selected">
                  {page}
                </button>
                <button
                  type="button"
                  className={
                    page === totalPages || totalPages === 0
                      ? "btn action-btn disabledButton "
                      : "btn action-btn"
                  }
                  onClick={() => setPage(page + 1)}
                  disabled={
                    page === totalPages || totalPages === 0 ? true : false
                  }
                >
                  {"Next >>"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
